import styled from "styled-components";

export const ScheduledSongCardStyle = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-height: 120px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    border-color: rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.08);
  }
  
  .card-image-wrapper {
    position: relative;
    width: 180px;
    min-width: 180px;
    overflow: hidden;
    flex-shrink: 0;
  }
  
  .card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .action-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    
    &.adding {
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    }
    
    &.removing {
      background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    }
  }
  
  .card-content {
    padding: 14px 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
  }
  
  .song-name {
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 4px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.3;
  }
  
  .artist-name {
    font-size: 13px;
    color: #b8b8b8;
    margin: 0 0 12px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .schedule-info {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  
  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 8px;
    
    &.notes {
      padding-top: 6px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
  
  .info-label {
    font-size: 11px;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    flex-shrink: 0;
  }
  
  .info-value {
    font-size: 12px;
    color: #e0e0e0;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
    .notes & {
      text-align: left;
      white-space: normal;
      overflow: visible;
    }
  }
  
  /* Tablet and smaller */
  @media (max-width: 768px) {
    min-height: 100px;
    
    .card-image-wrapper {
      width: 100px;
      min-width: 100px;
    }
    
    .card-content {
      padding: 12px;
    }
    
    .song-name {
      font-size: 14px;
      -webkit-line-clamp: 1;
    }
    
    .artist-name {
      font-size: 12px;
      margin-bottom: 8px;
    }
    
    .info-label {
      font-size: 10px;
    }
    
    .info-value {
      font-size: 11px;
    }
  }
  
  /* Mobile */
  @media (max-width: 480px) {
    .card-image-wrapper {
      width: 80px;
      min-width: 80px;
    }
    
    .action-badge {
      width: 24px;
      height: 24px;
      font-size: 16px;
      top: 6px;
      right: 6px;
    }
  }
`;

